// /* generated using openapi-typescript-codegen -- do no edit */
// /* istanbul ignore file */
// /* tslint:disable */
// /* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { PaginatedResponseDTO } from '../models/PaginatedResponseDTO';
import type { PaymentDTO } from '../models/PaymentDTO';
import { OpenAPI } from '../core/OpenAPI';

import { request as __request } from '../core/request';
import { ResponseDTO } from '../models/ResponseDTO';
import { PaymentDetailsDTO } from '../models/PaymentDetailsDTO';
import { PaymentStatisticResponseDTO } from '../models/PaymentStatisticResponseDTO';

export class PaymentsService {
  public static getPayments(
    offset: number,
    limit: number,
    begin: string,
    end: string,
    status?: string,
    search?: string,
  ): CancelablePromise<PaginatedResponseDTO<PaymentDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payments',
      query: {
        offset,
        limit,
        begin,
        end,
        status,
        search,
      },
    });
  }

  public static getPaymentDetails(
    operId: string | undefined,
  ): CancelablePromise<ResponseDTO<PaymentDetailsDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payments/{operId}',
      path: {
        operId: operId,
      },
    });
  }

  public static getPaymentsStatistic(
    begin: string,
    end: string,
  ): CancelablePromise<ResponseDTO<PaymentStatisticResponseDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payments/statistic',
      query: {
        begin,
        end,
      },
    });
  }
}
